import { render, staticRenderFns } from "./ClientPoolDetail.vue?vue&type=template&id=21f5b01e&scoped=true&"
import script from "./ClientPoolDetail.vue?vue&type=script&lang=js&"
export * from "./ClientPoolDetail.vue?vue&type=script&lang=js&"
import style0 from "./ClientPoolDetail.vue?vue&type=style&index=0&id=21f5b01e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f5b01e",
  null
  
)

export default component.exports